import React from "react";
import moment from "moment";
import MobileShiftCard from "./MobileShiftCard";
import { shiftType } from "services/shiftsService";

const getWorkIntervals = (shiftAssignment) => {
	const rawIntervals = shiftAssignment.time_intervals_from_manual
		? shiftAssignment.time_intervals
		: shiftAssignment.shift?.time_intervals;

	if (!Array.isArray(rawIntervals)) return [];

	const workIntervals = rawIntervals.filter((interval) => {
		if (!interval?.time_type) return true;
		return (
			interval.time_type.name === "Trabajo" || interval.time_type.work_time === true
		);
	});

	return workIntervals.length > 0 ? workIntervals : rawIntervals;
};

const MobilePlanDayList = ({ dayData, planAssignments, showAvatar = true }) => {
	const dayMoment = moment(dayData, "YYYY-MM-DD");
	const dayLabel = dayMoment.format("dddd D");

	const shifts = [];

	planAssignments.forEach((assignment) => {
		const employee = assignment.employee;
		const dayPlan = assignment.plans.find((p) => p.day === dayData);

		if (!dayPlan || !dayPlan.active) return;

		dayPlan.assignments.forEach((shiftAssignment) => {
			if (shiftAssignment.id === -1) return;
			if (!shiftAssignment.shift) return;
			if (shiftAssignment.shift.type !== shiftType.work) return;

			const workIntervals = getWorkIntervals(shiftAssignment);

			if (workIntervals.length > 1) {
				workIntervals.forEach((interval, index) => {
					shifts.push({
						employee,
						assignment: {
							...shiftAssignment,
							time_intervals_from_manual: true,
							time_intervals: [interval],
						},
						key: `${employee.id}-${shiftAssignment.id}-${index}-${interval.start}-${interval.end}`,
					});
				});
				return;
			}

			shifts.push({
				employee,
				assignment: shiftAssignment,
				key: `${employee.id}-${shiftAssignment.id}`,
			});
		});
	});

	if (shifts.length === 0) return null;

	return (
		<div className="mobile-plan-day">
			<div className="mobile-plan-day__header">{dayLabel}</div>
			<div className="mobile-plan-day__list">
				{shifts.map((item) => (
				<MobileShiftCard
					key={item.key}
					assignment={item.assignment}
					employee={item.employee}
					showAvatar={showAvatar}
				/>
				))}
			</div>
		</div>
	);
};

export default MobilePlanDayList;

